export default "__VITE_ASSET__CyS3EKrZ__"